/**
 * //"http://pdl.vimeocdn.com/48304/980/161714969.mp4?aksessionid=4f6c2c44504bca18b97697dc86ec9cb7&token=1367425069_c879ab8e09fa066e4a35c31ae4de581a&autoplay=yes");
                //"https://secure.vimeo.com/moogaloop.swf?clip_id=45672328&autoplay=yes" : "http://player.vimeo.com/video/45672328");
 */
define('controllers/mainslideshow',['require','flashDetect','ractivejs','utils','rv!templates/about/partials/mainslideshow'],function (require) {
    require('flashDetect');
    var Ractive = require('ractivejs');
    var utils = require('utils');
    var mainSlideShowController = {
        load: function (customerShortId, querystring) {
            var videoFlash = 'https://player.vimeo.com/video/65221554/?autoplay=yes';
            var videoNoFlash = 'https://player.vimeo.com/video/65221554/?autoplay=yes;';
            var defaultVideo = FlashDetect.installed ? videoFlash : videoNoFlash;
            mainSlideShowController.ractive = new Ractive({
                el: 'home-mainslideshow',
                template: require('rv!templates/about/partials/mainslideshow'),
                data: {
                    user: window.ServerData.user,
                    Settings: window.ServerData.Settings,
                    video: defaultVideo,
                    loading: true
                }
            });

            //load in customer stuff last, so we show the slide show right away and load in video link and signup pre-filled next
            mainSlideShowController.signUpController = window.app.controllerManager.controllers.signup[0];
            mainSlideShowController.signUpController.load(customerShortId, querystring).then(initVideoAndEnroll);
            function initVideoAndEnroll(result) {
                var customer = result.customer;
                mainSlideShowController.ractive.set('loading', false);
                mainSlideShowController.ractive.set('customer', customer);
                var haveCust = customer != null;
                var showVideo = !haveCust || customer.VideoUrl !== 'none';
                var videoToShow = haveCust && customer.VideoUrl != null && customer.VideoUrl !== '' ? customer.VideoUrl : defaultVideo;
                mainSlideShowController.ractive.set('video', showVideo ? videoToShow : null);
            }

            var captionElement = $("#captionText"),
                captionBackground = $("#caption");

            mainSlideShowController.slideTimer = setInterval(function() {
                var prevImage = $('#top_slideshow div:first-child'),
                    nextMessage = prevImage.next().attr('alt');

                if (nextMessage != undefined && nextMessage.trim() != "") {
                    captionElement.text(nextMessage);
                    captionBackground.css("width", captionElement.css("width"));
                }

                prevImage.fadeOut().next().fadeIn().end().appendTo('#top_slideshow');
            }, 5000);

            $(".video").fancybox(Utilities.specialFancy);

            var playVideoNow = utils.querystring('v', querystring) !== '';
            if (playVideoNow) {
                $("#hidden_videoAnchor").first().trigger("click");
            }
        },

        unload: function () {
            window.clearInterval(mainSlideShowController.slideTimer);
            if (mainSlideShowController.signUpController != null) mainSlideShowController.signUpController.unload();
            if (mainSlideShowController.ractive != null) mainSlideShowController.ractive.teardown();
        }
    };
    return mainSlideShowController;
});
